import React, {useState, useEffect} from 'react'
// Styles
import './invtfrnd.style.css'
// Images
import Banner from '../../assets/images/banner/invitefriends-banner.png'
import LinkIcon from '../../assets/images/icons/link-icon.png'
import SendIcon from '../../assets/images/icons/sendalt-icon.png'
// Actions
import { Base_API } from '../../_actions/matcher'
// Icons
import RoundCross from '../../assets/images/icons/gray-cross.png'
// React Share
import {
    LineIcon, 
    LineShareButton, 
    FacebookIcon, 
    FacebookShareButton, 
    FacebookMessengerShareButton, 
    FacebookMessengerIcon
} from 'react-share'
// Alert
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
// Toast
import {toast as notify, Toaster} from 'react-hot-toast'
import { DecryptedOBJ } from '../../utils/Encryption'


function InviteFriends() {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~ useState ~~~~~~~~~~~~~~~~~~~~~~~~~

    const [fbAppID, setFbAppID] = useState(process.env.REACT_APP_FBAPPID);
    const [lineInfo, setLineInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pageDetail, setPageDetail] = useState({
        inviterLink: '',
        inviterLinkText: ''
    });

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ useEffect ~~~~~~~~~~~~~~~~~~~~~~~~~

    useEffect(() => {
        dataInit();
    },[])

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Init ~~~~~~~~~~~~~~~~~~~~~~~~~

    const dataInit = async() => {
        await lineProfileInit(); 
        handlerLoader('inactive'); 
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Callback ~~~~~~~~~~~~~~~~~~~~~~~~~

    const lineProfileInit = () => {
        return new Promise(async resolve => {
            let lineInfo = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(!!lineInfo)
            {
                let userID = lineInfo.user_id;
                let origin = window.location.origin;

                setLineInfo(lineInfo);
                setPageDetail({
                    ...pageDetail,
                    inviterLink: `${Base_API.main}${Base_API.pathWeb}/n-health/inviteewelcome/${userID}`,
                    inviterLinkText: `inviteewelcome/${userID}`
                })
            }else
            {
                Redirect('login-destination');
            }
            resolve();
        })
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Handle ~~~~~~~~~~~~~~~~~~~~~~~~~

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const handleSubmit = (type) => {
        if(type === 'copy')
        {
            Clipboard('invitercode');
        }
        if(type === 'share')
        {
            openModalShare();
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Utils ~~~~~~~~~~~~~~~~~~~~~~~~~

    const Clipboard = type => {
        switch(type)
        {
            case "invitercode":
                navigator.clipboard.writeText(pageDetail.inviterLink)
                .then(() => {
                    notify.success('คัดลอกลิงก์สำเร็จ', {duration: 2000});
                })        
                break
            ;
        }
    }

    const Redirect = dest => {
        switch(dest)
        {
            case "login-destination":
                window.location.href = `${Base_API.pathWeb}/n-health/login-destination` 
                break
            ;
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Modal ~~~~~~~~~~~~~~~~~~~~~~~~~

    const openModalShare = () => {
        MySwal.fire({
            html: btnShareGroup,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false 
        });
    };
    const closeModalShare = () => {
        MySwal.close();
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Alert ~~~~~~~~~~~~~~~~~~~~~~~~~

    const showAlertSuccess = (title, msg) => {
        Swal.fire({
            title: title,
            text: msg,
            icon: 'success',
            confirmButtonText: 'ตกลง',
            allowOutsideClick: false,
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }
    const showAlertError = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            allowOutsideClick: false,
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Component ~~~~~~~~~~~~~~~~~~~~~~~~~

    let btnShareGroup = 
        <div className='btnshare-wrap'>
            <div className="btnshare-group">
                <FacebookShareButton
                    url={pageDetail.inviterLink}
                    quote={'ชวนเพื่อนมาสมัครสมาชิกกับ N Health Club Card เพื่อรับสิทธิพิเศษอีกมากมาย'}
                    hashtag={'#nhealthclubcardinvitefriends'}
                >
                    <FacebookIcon size={40} round />
                </FacebookShareButton>
                <LineShareButton
                    url={pageDetail.inviterLink}
                    title={'ชวนเพื่อนมาสมัครสมาชิกกับ N Health Club Card เพื่อรับสิทธิพิเศษอีกมากมาย'} 
                >
                    <LineIcon size={40} round />
                </LineShareButton>
                <FacebookMessengerShareButton
                    url={pageDetail.inviterLink}
                    appId={fbAppID}
                >
                    <FacebookMessengerIcon size={40} round />
                </FacebookMessengerShareButton>
            </div>
            <img 
                src={RoundCross} 
                className="close-icon"
                onClick={closeModalShare}
            />
        </div>
    ;

    // ~~~~~~~~~~~~~~~~~~~~~~~~~ Render ~~~~~~~~~~~~~~~~~~~~~~~~~

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="invtfrnds-container">
                {/* header */}
                <h1 className="header-text">เชิญเพื่อน</h1>
    
                {/* Banner */}
                <img 
                    src={Banner} 
                    className="banner-img"
                />
    
                <div className="card">
                    <p className="label">ข้อความเชิญเพื่อน</p>
                    <div className="message">
                        <span>
                            คำเชิญจากเพื่อน สำหรับสมัครสมาชิกกับ N Health Club Card เพื่อรับสิทธิพิเศษอีกมากมาย คลิกเลย!
                        </span>
                        <a href={pageDetail.inviterLink} className='link'>{pageDetail.inviterLinkText}</a>
                    </div>
                </div>
    
                <div className="btn-group">
                    <button 
                        className="copy"
                        onClick={() => handleSubmit('copy')}
                    >
                        <img src={LinkIcon} />
                        <span>คัดลอก</span> 
                    </button>
                    <button 
                        className="share"
                        onClick={() => handleSubmit('share')}
                    >
                        <img src={SendIcon} />
                        <span>แชร์ให้เพื่อน</span> 
                    </button>
                </div>
    
                <Toaster/>
            </div>
        )
    }
}

export default InviteFriends